const { D, getStochasticOscillatorD } = require('./stochasticOscillator');
const { getFixedLinesData } = require('./utils');

function getSeries(periods, bars, fullBarData, localize) {
  let result = [];
  let period = periods[0] || 14;

  result.push({
    name: localize({ id: 'symbol.details.chart.tooltip.overbought' }),
    type: 'line',
    color: '#ff2800',
    yAxis: 'stochasticSlow',
    data: getFixedLinesData(bars, 80),
    tooltip: { yDecimals: 2 },
    zIndex: 4
  });

  result.push({
    name: localize({ id: 'symbol.details.chart.tooltip.oversold' }),
    type: 'line',
    color: '#0055cc',
    yAxis: 'stochasticSlow',
    data: getFixedLinesData(bars, 20),
    tooltip: { yDecimals: 2 },
    zIndex: 3
  });

  result.push({
    id: 'StochasticSlowK',
    name: localize({ id: 'symbol.details.chart.tooltip.slowK' }),
    type: 'line',
    color: '#008c56',
    yAxis: 'stochasticSlow',
    // StochasticSlowK is the D line from Fast
    data: getStochasticOscillatorD(bars, fullBarData, period),
    tooltip: { yDecimals: 2 },
    zIndex: 1
  });

  result.push({
    id: 'StochasticSlowD',
    name: localize({ id: 'symbol.details.chart.tooltip.slowD' }),
    type: 'line',
    color: '#EFB84D',
    yAxis: 'stochasticSlow',
    data: D(bars, fullBarData, period),
    tooltip: { yDecimals: 2 },
    zIndex: 2
  });

  return result;
}

module.exports = {
  getSeries: getSeries
};
